// 待宵の花嫁「ヴェールの招待」(veilInvitation・床の帯 kind 'veil') の見た目 — 前の壁の動きで、ヴェールの絵 (2026-10-23・比較版)。
//
// 作者の答え (10-23・検収ページ kensyu-bride-veil-tsunami-1023.html):
//   R-1「表示の仕方と言うか、波の起こり方とかはこれ (7月の壁) を元にしてほしいんだけど、それを布でやってほしい。おそらく画像を使うのかな？」
//   W-1 (1回目のコードだけの一枚布へ)「動きが前の壁と違う」「コードだけで表現してほしいわけじゃない」
// だから:
//   動き = 前の壁 (render.ts drawVeilWall) のコードそのもの。柱の数・上の縁の高さの式・横の揺れ・3層・予告の見え方・
//     当たりの始まりの根元の光・両端から寄る締まりの光・消え方 (当たりの終わりで薄れる) は全部あちらで計算する。
//   変えるのは①布本体の塗りだけ = 各柱を、Codex が描いたヴェールの幕の絵の縦の帯で塗る (柱の上の縁の高さまで縦に伸ばす)。
//     柱の境目で段がつかないよう、1柱を SUB 本の細い帯に分け、隣の柱の値へ線形につなぐ (柱の真ん中は前の壁と同じ値)。
//   絵が読めていない時は前の壁と同じ塗り (render.ts 側でそのまま落ちる)。
// 当たりは変えない。弾けない合図の菫 (purple_swap 'unparry') は前の壁のまま (根元の照り・床の境目)。描くだけ。

const CURTAIN_SRC = '/sprites/fx/hazard/bride_veil_curtain.png'
// 幕の絵の中で床から上の縁までが占める縦の範囲 (絵の上の余白を除く・0..1)。絵を差し替えたら測り直す。
export const CURTAIN_TOP_FRAC = 0.0
export const SUB = 4   // 1柱を何本の細い帯に分けるか

let curtainImg: HTMLImageElement | null = null
let curtainLoading = false
/** 幕の絵の読み込み (1回)。 */
export function preloadBrideVeilCurtain(): void {
  if (curtainImg || curtainLoading || typeof Image === 'undefined') return
  curtainLoading = true
  const img = new Image()
  img.onload = () => { curtainImg = img }
  img.onerror = () => { curtainLoading = false }
  img.src = CURTAIN_SRC
}
export function setBrideVeilCurtainForTest(img: HTMLImageElement | null): void { curtainImg = img }
/** 読めていれば幕の絵 (読めていなければ読み込みを始めて null)。 */
export function brideVeilCurtain(): HTMLImageElement | null {
  if (!curtainImg) preloadBrideVeilCurtain()
  return curtainImg
}

/** 柱 i の値を、柱の真ん中を通る線形のつなぎで u (柱の単位・0.5 が柱0の真ん中) の所で引く。 */
export function lerpCols(f: (i: number) => number, cols: number, u: number): number {
  const x = u - 0.5
  const i0 = Math.max(0, Math.min(cols - 1, Math.floor(x)))
  const i1 = Math.max(0, Math.min(cols - 1, i0 + 1))
  const k = Math.max(0, Math.min(1, x - i0))
  return f(i0) + (f(i1) - f(i0)) * k
}

/**
 * 前の壁の①布本体の1層を、幕の絵の縦の帯で塗る。colTop / swayOf は前の壁と同じ式 (render.ts が渡す)。
 * srcShift = 層ごとに絵の横の取り出し位置をずらす割合 (3層が同じ絵の重ね写しに見えないように)。
 */
export function paintVeilCurtainLayer(
  ctx: CanvasRenderingContext2D, img: HTMLImageElement, xStart: number, w: number, floorY: number,
  fullH: number, cols: number, colTop: (i: number) => number, swayOf: (i: number) => number,
  alpha: number, srcShift: number,
): void {
  if (alpha <= 0.005) return
  const iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height
  if (!iw || !ih) return
  const srcTop = ih * CURTAIN_TOP_FRAC
  const srcH = ih - srcTop
  const scale = fullH / srcH             // 全高の柱で絵の縦がちょうど収まる倍率 (横もこれで取り出す)
  const cw = w / cols
  const sw = cw / SUB                    // 細い帯1本の幅 (画面)
  const srcW = sw / scale                // 同じ帯の絵の中の幅
  const n = cols * SUB
  ctx.save()
  ctx.globalAlpha = Math.min(1, alpha)
  for (let s = 0; s < n; s++) {
    const u = (s + 0.5) / SUB            // 帯の真ん中 (柱の単位)
    const h = lerpCols(colTop, cols, u)
    const sway = lerpCols(swayOf, cols, u)
    let sx = ((s * srcW) + srcShift * iw) % iw
    if (sx + srcW > iw) sx = Math.max(0, iw - srcW)
    ctx.drawImage(img, sx, srcTop, srcW, srcH, xStart + s * sw + sway, floorY - h, sw + 0.6, h)
  }
  ctx.restore()
}
